import '../css/app.css';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import { initBackToTop } from 'modules/backToTop';
import { initCategoryNav } from 'modules/categoryNavigation';
import { flashMessageRedirect } from 'modules/flashParam';
import { initGleam } from 'modules/gleam';
import { handleSearchFocus } from 'modules/handleSearchFocus';
import { initSearch } from 'modules/search';
import { loadUserStats } from 'modules/userStats';
if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        // dsn:
        //   'https://90160204745e4298842c10d2eb7cb24f@o110755.ingest.sentry.io/1810868',
        dsn: 'https://1cb9cf46c964426a94d4ef5ab997b722@o4503926274981888.ingest.sentry.io/4503926276292608',
        integrations: [new Integrations.BrowserTracing()],
        environment: window.location.host,
        tracesSampleRate: 0.2,
    });
}
/*
  Simplistic way to asynchronously load webpack chunks.

  Example usage:

  {% content_for 'body:bottom' %}
  <script>LoadPageModule('product/show');</script>
  {% endcontent_for %}
*/
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
window.LoadPageModule = (slug) => import(`./pages/${slug}`);
loadUserStats();
// initializeDrawers();
handleSearchFocus();
flashMessageRedirect();
initCategoryNav();
initBackToTop();
initGleam();
initSearch();
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/Countdown').then(({ initCountdown }) => {
        els.forEach(initCountdown);
    });
})(document.querySelectorAll('[data-countdown]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/WatchButton/WatchButtonManager').then(({ init }) => {
        init(Array.from(els));
    });
})(document.querySelectorAll('[data-watch-button]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('apps/save_search_button/initialize').then(({ initSaveSearchButton }) => {
        els.forEach(initSaveSearchButton);
    });
})(document.querySelectorAll('[data-save-search-button]'));
((el) => {
    if (!el) {
        return;
    }
    import('apps/user_menu/initialize').then(({ initUserMenu }) => {
        initUserMenu(el);
    });
})(document.getElementById('user-menu'));
((el) => {
    if (!el) {
        return;
    }
    import('apps/email_notifications/initialize').then(({ initUserMenu }) => {
        initUserMenu(el);
    });
})(document.getElementById('receive-email-notifications'));
((el) => {
    if (!el) {
        return;
    }
    import('apps/ship_action/initialize').then(({ initShipAction }) => {
        initShipAction(el);
    });
})(document.getElementById('ship-action'));
((el) => {
    if (!el) {
        return;
    }
    import('apps/notifications/init').then(({ initNotifications }) => {
        initNotifications(el);
    });
})(document.getElementById('notification-menu'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/toggler').then(({ init }) => {
        els.forEach(init);
    });
})(document.querySelectorAll('[data-toggler]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/tooltip').then(({ init }) => {
        els.forEach(init);
    });
})(document.querySelectorAll('[data-tooltip]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/disableOnSubmit').then(({ init }) => {
        els.forEach(init);
    });
})(document.querySelectorAll('[data-disable-on-submit]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/selectNav').then(({ initSelectNav }) => {
        els.forEach(initSelectNav);
    });
})(document.querySelectorAll('[data-select-nav]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/submitOnChange').then(({ initSubmitOnChange }) => {
        els.forEach(initSubmitOnChange);
    });
})(document.querySelectorAll('[data-submit-on-change]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/submitOnBlur').then(({ initSubmitOnBlur }) => {
        els.forEach(initSubmitOnBlur);
    });
})(document.querySelectorAll('[data-submit-on-blur]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/showPassword').then(({ initShowPassword }) => {
        els.forEach(initShowPassword);
    });
})(document.querySelectorAll('[data-show-password]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/showCharsLeft').then(({ initShowCharsLeft }) => {
        els.forEach(initShowCharsLeft);
    });
})(document.querySelectorAll('[data-show-chars-left]'));
// --- Subscribe Helper ---
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/subscribeHelper').then(({ initSub }) => {
        els.forEach(initSub);
    });
})(document.querySelectorAll('[data-cancel-subscription-form]'));
// --- Side Menu Count Init ---
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/sideMenuCounts').then(({ initSideMenuCounts }) => {
        els.forEach(initSideMenuCounts);
    });
})(document.querySelectorAll('[data-side-menu]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/scrollSpy').then(({ initScrollSpy }) => {
        els.forEach((el) => initScrollSpy(el));
    });
})(document.querySelectorAll('.scroll-spy a.scroll-spy-link'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/syncInputs').then(({ initSyncInputs }) => {
        initSyncInputs(Array.from(els));
    });
})(document.querySelectorAll('[data-sync-input]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/menuToggler').then(({ initMenuToggler }) => els.forEach(initMenuToggler));
})(document.querySelectorAll('[data-menu-toggler]'));
((els) => {
    if (els.length === 0) {
        return;
    }
    import('modules/timeago').then(({ init }) => {
        init(els);
    });
})(document.querySelectorAll('.timeago'));
